<template>
  <div>
    <div>
      <div class="row">
        <div class="col-12">
          <fg-input
            type="numeric"
            v-model="title"
            label="Название (имя участника)"
          ></fg-input>
        </div>
        <div class="col-12">
          <fg-input
            v-model="title_additional"
            type="numeric"
            label="Доп. название"
          ></fg-input>
        </div>

        <div class="col-12">
          <button class="btn btn-sm btn-warning btn-icon" @click="addPart">
            <span class="ti-save"></span>
            Добавить нового участника
          </button>
        </div>
      </div>
    </div>
    <br />
    <hr />
    <list
      :itemLink="itemLink"
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :params="params"
      :disable_add="true"
      :isUpdate="true"
      :searchDisable="false"
      :functions="functions"
      @change="change"
      @changeFunction="changeFunction"
    />
  </div>
</template>

<script>
import List from "../../List";

export default {
  name: "groups",
  components: {
    List,
  },
  props: ["id"],
  data() {
    return {
      add: [],

      title: "",
      title_additional: "",

      functions: [
        {
          id: 1,
          title: "Сбросить выигрыши участника",
        },
        {
          id: 2,
          title: "Удалить участника-(ов)",
        },
      ],

      params: {
        id: null,
        updatedAt: null,
      },
      modalCreate: "create-group",
      modalAdd: "students-table-selector",
      removeLink: "student/remove",
      cardLink: "parchases",
      itemLink: "admin/draws/participants",
      value: [],
      columns: [
        {
          key: "id",
          title: "ID",
          checkbox: true,
          control: false,
          align: "left",
          image: false,
        },
        {
          key: "title",
          title: "Название (участник)",
          checkbox: false,
          control: false,
          align: "left",
          image: false,
        },
        {
          key: "title_additional",
          title: "Доп. название",
          checkbox: false,
          control: false,
          align: "left",
        },
        {
          key: "label",
          title: "Метка",
          checkbox: false,
          control: false,
          align: "left",
        },
      ],
    };
  },
  created() {
    this.params.id = this.id;
  },
  methods: {
    addPart() {
      this.$loading(true);
      this.$http
        .post(`admin/draws/participants/create`, {
          id: this.id,
          participants: [
            {
              title: this.title,
              title_additional: this.title_additional,
            },
          ],
        })
        .then((response) => {
          this.title_additional = this.title = "";
          this.params.updatedAt = Date.now();
          this.$notify({
            title: "Участник",
            message: "Успешно добавлен",
            icon: "ti-save",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "success",
          });
        })
        .catch(() => {})
        .finally(() => {
          this.$loading(false);
        });
    },
    changeFunction(val) {
      if (val === 1) {
        this.clearPart();
      } else if (val === 2) {
        this.deletePart();
      }
    },
    change(val) {
      this.value = Array.isArray(val) ? val : [val];
    },

    clearPart(type) {
      this.$loading(true);
      if (this.id) {
        this.$http
          .put(`admin/draws/participants/clear`, {
            id: this.id,
            participants: this.value,
          })
          .then((response) => {
            this.$notify({
              title: "Участнки",
              message: "Успешно сброшен выйгрыш",
              icon: "ti-save",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });
          })
          .catch(() => {})
          .finally(() => {
            this.params.updatedAt = Date.now();
            this.params.clear = true;
          });
      }
    },
    deletePart(type) {
      this.$loading(true);
      if (this.id) {
        this.$http
          .delete(`admin/draws/participants/delete`, {
            data: {
              id: this.id,
              participants: this.value,
            },
          })
          .then((response) => {
            this.$notify({
              title: "Участнки",
              message: "Успешно удалаено",
              icon: "ti-save",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });
          })
          .catch(() => {})
          .finally(() => {
            this.params.updatedAt = Date.now();
                   this.params.clear = true;
          });
      }
    },
  },
};
</script>
<style>
</style>
